export async function  lfnSetpassword(app_key, upwd, upwd1, returl){
    try{
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ app_key: app_key, upwd : upwd, upwd1: upwd1})
        }

        const chek_login = await fetch('/Logon/ChangePwd', requestOptions)
        .then(async response => {
            const response_data = await response.json();
            if (!response.ok) {
                // get error message from body or default to response status
                const error = (response_data && response_data.message) || response.status;
                    return Promise.reject(error);
            }
            if (response_data.err == 0) {
                if (response_data.result == "S") {
                    alert(" Your password has been successfully changed.\n Please log in again.");
                    top.location.href  = returl;        
                }
                else {
                    alert(response_data.resultMsg);
                }
            }
            else    
            {
                alert(response_data.errMsg || "");                
            } 
            return chek_login;
      })
      .catch(function (err) {
        return err;
      });
    }catch(err){
        return err;
    } 
}